module.exports = __webpack_public_path__ + "img/oh05.4d9bcc21.png";